export * from './block-theme';
export * from './colors';
export * from './fonts';
export * from './theme';
export * from './typographies';
export * from './variants';
export * from './typings.d';

/**
 * Gets the value of an object's properties (looping through the depths)
 * @param properties [array] Array of the object properties to fetch from
 * @param parent [object] Object to get the value from
 * @returns value fetched from the object properties
 */
export const getValueFromProperties = (properties, parent) => {
	return properties.reduce((previous, current) => {
		if (previous === undefined || previous === null) {
			return null;
		}

		return previous[current] || null;
	}, parent);
};

/**
 * Gets the value of an object's keypath
 * @param properties [string] String of the object keypath to fetch from => must start with a '@'
 * @param parent [object] Object to get the value from
 * @returns value fetched from the object keypath
 */
export const getValueFromKeypath = (keypath, parent) => {
	// bail early if parent is invalid
	if (typeof parent === 'undefined') {
		console.warn(
			'Tried to convert a keypath in an undefined parent.',
			keypath,
			parent
		);
		return keypath;
	}

	if (keypath?.charAt(0) === '@') keypath = keypath.substring(1);
	else return keypath; // It's not a keypath

	const result = getValueFromProperties(keypath?.split('.'), parent);

	return result;
};
